import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateDirective } from './translate.directive';
import { TranslatePipe } from './translate.pipe';
import { DefaultTranslateAdapter, TranslateAdapter, TranslateService } from './translate.service';

@NgModule({
  declarations: [
    TranslateDirective,
    TranslatePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TranslateDirective,
    TranslatePipe
  ],
  providers: [
    TranslateService
  ]
})
export class TranslateModule {
  static forRoot(config: any = {}): ModuleWithProviders<TranslateModule> {
    return {
      ngModule: TranslateModule,
      providers: [
        config.adapter ? config.adapter : {
          provide: TranslateAdapter,
          useClass: DefaultTranslateAdapter,
        },
      ],
    };
  }
}
